import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyCreatePostback = lazy(() => import('./CreatePostback'));

export const CreatePostback: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyCreatePostback {...props} />
	</Suspense>
);
